import { Link } from '@everlywell/ui-kit';
import MeasuredItemsModal, { Item } from 'components/MeasuredItemsModal';
import React, { useState } from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

export type MarkdownLinkProps = {
  /** This is href where the link will navigate to if external */
  href?: string;
  /** This is the slug of the current product */
  slug: string;
  /** Children of the link */
  children: React.ReactNode;

  whatIsMeasuredData: Queries.PDPQuery['whatsMeasured']['nodes'][0];
};

/**
 * [Add the description for what this component does here].
 */
const MarkdownLink = (props: MarkdownLinkProps) => {
  const { href, children, slug, whatIsMeasuredData, ...rest } = props;
  // TODO: refactor this logic to not use old models
  const [isListModalOpen, setIsListModalOpen] = useState<boolean>(false);

  const whatsMeasuredSection = props.whatIsMeasuredData;

  if (!whatsMeasuredSection) return null;
  if (!whatsMeasuredSection.listOfContentSections) return null;

  const formattedListOfItems: Item[] =
    whatsMeasuredSection.listOfContentSections.map((item) => ({
      image: item?.image?.file?.url || '',
      title: item?.title ?? '',
      items: item?.description?.description?.split('\n') || [],
    }));

  const onListModalOpen = (e: React.SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    setIsListModalOpen(true);
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_MODAL,
      data: {
        label: 'PDP - Overview Section',
        slug,
        component: 'ListModal',
      },
    });
  };

  const formattedHref = href?.includes('replaceurl') ? '#' : href;

  return (
    <>
      <Link
        textDecoration={'underline'}
        onClick={onListModalOpen}
        href={formattedHref}
        {...rest}
      >
        {children}
      </Link>
      <MeasuredItemsModal
        open={isListModalOpen}
        openHandler={setIsListModalOpen}
        listOfItems={formattedListOfItems}
        modalTitle={whatsMeasuredSection?.modalTitle || ''}
      />
    </>
  );
};

export default MarkdownLink;
